import { render, staticRenderFns } from "./file-chips-input.vue?vue&type=template&id=9f25fad6&"
import script from "./file-chips-input.vue?vue&type=script&lang=js&"
export * from "./file-chips-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports